import styled from 'styled-components';
import { IonHeader, IonIcon, IonModal, IonToolbar, isPlatform } from '@ionic/react';

export const SubscriptionCardContainer = styled.div`
  margin-top: -16px;
  margin-bottom: 30px;
`;
export const FullWidthModal = styled(IonModal)`
  &::part(content) {
    width: 100%;
    height: 100%;
  }
`;
export const ModalHeading = styled.h4`
  padding: 10px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;

  max-width: 190px;
  margin: 0 auto;

  text-align: center;

  color: #1d201f;

  @media screen and (max-width: 379px) {
    font-size: 12px;
  }
`;
export const ModalHeadingIcon = styled(IonIcon)`
  cursor: pointer;
  color: #1d201f;
  height: 30px;
  width: 30px;
`;
export const SurveyForm = styled.form`
  text-align: left;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 23px;
  padding-left: 25px;
  padding-right: 25px;
`;
export const DismissButtonContainer = styled.button`
  padding: 16px 16px;
  background-color: white;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  color: #5b5b5b;

  &:disabled,
  &[disabled] {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;

    color: #c1c1c1;
  }
`;
export const ApproveButtonContainer = styled.button`
  background: #177590;
  border-radius: 10px;
  padding: 16px 16px;
  gap: 10px;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  color: #ffffff;

  &:disabled,
  &[disabled] {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;

    color: #c1c1c1;
  }
`;
export const ModalButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 5.5px;

  button {
    width: 100%;
  }
`;

export const CustomHeader = styled(IonHeader)`
  &:after {
    display: none;
  }
`;

export const HeaderToolbar = styled(IonToolbar)`
  padding: 0;

  &::after {
    display: none !important;
  }
`;

export const FullWidthItem = styled.div`
  ${!isPlatform('desktop') &&
  `
      width: 100vw;
      position: relative;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      margin-right: -50vw;
  `}

  padding: 16px ${!isPlatform('desktop') ? '16px' : 0};

  &:first-child {
    padding-top: 22px;
    border-top: none;
  }
`;
